const normalizeName = (value) => String(value ?? "").trim().toLowerCase();

export const buildTeamMaps = (teams = []) => {
  const byId = new Map();
  const byName = new Map();
  teams.forEach((team) => {
    if (!team) return;
    if (team.id != null) {
      byId.set(String(team.id), team);
    }
    if (team.team_name) {
      byName.set(normalizeName(team.team_name), team);
    }
  });
  return { byId, byName };
};

export const resolveTeamRecord = (teamId, teamName, maps) => {
  if (!maps) return null;
  const { byId, byName } = maps;
  if (teamId != null) {
    const byIdHit = byId?.get(String(teamId));
    if (byIdHit) return byIdHit;
  }
  if (teamName) {
    const byNameHit = byName?.get(normalizeName(teamName));
    if (byNameHit) return byNameHit;
  }
  return null;
};

export const buildPlayerTeamLookup = (playerStats = [], maps) => {
  const countsByPlayer = new Map();

  playerStats.forEach((stat) => {
    const playerId = stat?.player_id ?? stat?.playerId;
    if (!playerId) return;

    const teamId = stat?.team_id ?? stat?.teamId;
    const teamName = stat?.team_name ?? stat?.teamName;
    const resolvedTeam = resolveTeamRecord(teamId, teamName, maps);
    const resolvedId = resolvedTeam?.id ?? teamId ?? null;
    const resolvedName = resolvedTeam?.team_name ?? teamName ?? "";
    if (!resolvedId && !resolvedName) return;

    const key = resolvedId != null ? `id:${resolvedId}` : `nm:${normalizeName(resolvedName)}`;
    const bucket = countsByPlayer.get(String(playerId)) || new Map();
    const entry = bucket.get(key) || { count: 0, teamId: resolvedId, teamName: resolvedName };
    entry.count += 1;
    if (!entry.teamName && resolvedName) entry.teamName = resolvedName;
    if (!entry.teamId && resolvedId != null) entry.teamId = resolvedId;
    bucket.set(key, entry);
    countsByPlayer.set(String(playerId), bucket);
  });

  const result = new Map();
  countsByPlayer.forEach((bucket, playerId) => {
    let best = null;
    bucket.forEach((entry) => {
      if (!best || entry.count > best.count) best = entry;
    });
    if (best) result.set(String(playerId), best);
  });

  return result;
};

export const resolvePlayerTeamInfo = (player, maps, playerTeamLookup) => {
  if (!player) return { teamId: null, teamName: "", teamLogo: "" };

  const rawTeamId = player.team_id ?? player.teamId;
  const rawTeamName = player.team_name ?? player.teamName;
  const directTeam = resolveTeamRecord(rawTeamId, rawTeamName, maps);
  const lookupTeam = playerTeamLookup?.get(String(player.id || ""));
  const lookupRecord = resolveTeamRecord(lookupTeam?.teamId, lookupTeam?.teamName, maps);
  const resolved = directTeam || lookupRecord;

  const teamId = resolved?.id ?? rawTeamId ?? lookupTeam?.teamId ?? null;
  const teamName = resolved?.team_name ?? rawTeamName ?? lookupTeam?.teamName ?? "";
  const teamLogo = resolved?.logo || resolved?.team_logo || resolved?.logo_url || "";

  return { teamId, teamName, teamLogo };
};
